import React from 'react';
import { Play, Sparkles } from 'lucide-react';

export const REASON_COPY = {
  red: 'Tricky one! Turn it green for bonus Sparks ⚡',
  amber: 'Nearly there! One more go could make it green 💪',
  new: 'Something new for your year group ✨',
  stretch: 'Super challenge from the year above 🚀',
};

/** The featured "Recommended for you" block on the Home Learning hub. */
export default function RecommendedTile({ recommendation, onStart, onHoverChange }) {
  const { topic, lesson, reason } = recommendation;
  return (
    <button
      type="button"
      onClick={onStart}
      onMouseEnter={() => onHoverChange?.(true)}
      onMouseLeave={() => onHoverChange?.(false)}
      onFocus={() => onHoverChange?.(true)}
      onBlur={() => onHoverChange?.(false)}
      data-testid="home-recommended"
      className="group relative flex w-full flex-col gap-3 overflow-hidden rounded-3xl bg-amber-300 p-6 text-left text-amber-950 shadow-md transition-all duration-300 ease-out hover:-translate-y-1.5 hover:shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-300 active:scale-95 motion-reduce:transform-none motion-reduce:transition-none md:flex-row md:items-center md:justify-between"
    >
      <Sparkles
        className="absolute -right-4 -top-4 h-28 w-28 opacity-20 transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110 motion-reduce:transform-none"
        aria-hidden="true"
      />
      <span className="min-w-0">
        <span className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-wide">
          <Sparkles className="h-4 w-4" aria-hidden="true" />
          Recommended for you
        </span>
        <span className="mt-1 block text-2xl font-extrabold md:text-3xl">{lesson.lessonId.title}</span>
        <span className="block text-base font-semibold">
          {topic.topic} · {REASON_COPY[reason]}
        </span>
      </span>
      <span className="relative inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-full bg-indigo-600 px-5 font-bold text-white shadow transition-transform duration-200 group-hover:scale-105 motion-reduce:transform-none">
        <Play className="h-4 w-4 fill-current" aria-hidden="true" />
        Let's go!
      </span>
    </button>
  );
}
